import DividerWidthText from 'components/Grounding/DividerWidthText'
import GroundingVehicleDetails from 'components/Grounding/GroundingVehicleDetails'
import { Field, Form, Formik, FormikProps, FormikValues, useFormikContext } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import { Col, Row, Form as Checkbox, Button, Alert } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FormControl as Input } from 'react-bootstrap'
import { DispositionOption, IGroundingForm, groundingValueValidateSchema } from 'types/Grounding/groundingTypes'
import {
  Campaign,
  DropDownGroup,
  GroundingDispositionData,
  GroundingIndication,
  LocationDropDown
} from '../../types/Grounding/GroundingResult'
import { DropdownList } from 'layouts/DropdownList'
import {
  ERROR_ODOMETER_INVALID_INPUT,
  GENERAL_ERROR_MESSAGE,
  GND_DISPOSITION_PURCHASE_CONFIRM,
  GND_DISPOSITION_RETURN_CONFIRM,
  RecallDetailStatus
} from 'common/constants'
import {
  StyledDatePickerWithIcon,
  StyledGroundingAdditional,
  StyledGroundingItem,
  StyledGroundingOdometer,
  StyledGroundingOption,
  StyledGroundingOptions,
  StyledGroundingReview,
  StyledLabelRequired
} from './GroundingOptions.styled'
import { GroundingConfirmModal } from 'components/Grounding/GroundingConfirmModal'
import DateTimePicker from 'components/DateTimePicker'
import { addDays } from 'utils/dateUtils'
import { Calendar } from 'icons/Calendar'
import { useGlobalStore } from 'store/useGlobalStore'
import { AddressModal } from 'components/Grounding/AddressModal'
import { IAddress } from 'types/accountTypes'
import { saveAddress } from 'apis/userApis'
import shallow from 'zustand/shallow'
import { useGroundingStore } from './store/useGroundingStore'
import { OverlayLoader } from 'components/Loader'
import RecallModal from 'components/Grounding/RecallModal'
import { useHistory } from 'react-router-dom'
import { ISystemSetting } from 'types/baseTypes'
import { GroundingRenderStep } from './store/RenderStep'
import { useGroundingActionStore } from './store/useGroundingActionStore'

interface IProps {
  setShowCancelModal: (data: boolean) => void
}

const GroundingOptions = ({ setShowCancelModal }: IProps) => {
  const [
    groundingData,
    setGroundingData,
    setShowTerms,
    alreadyConfirmRecall,
    setAlreadyConfirmRecall,
    alreadyConfirmGeneralModal,
    setAlreadyConfirmGeneralModal
  ] = useGroundingStore(
    (state) => [
      state.groundingData,
      state.setGroundingData,
      state.setShowTerms,
      state.alreadyConfirmRecall,
      state.setAlreadyConfirmRecall,
      state.alreadyConfirmGeneralModal,
      state.setAlreadyConfirmGeneralModal
    ],
    shallow
  )
  const [setActiveStep, isSubmit, setIsSubmit] = useGroundingActionStore(
    (state) => [state.setActiveStep, state.isSubmit, state.setIsSubmit],
    shallow
  )
  const [isValidate, setIsValidate] = useState(isSubmit)
  const { CurrentBuyerID } = useGlobalStore((state) => state.userClaims)
  const { getSystemSetting } = useGlobalStore()
  const [getLocalText] = useGlobalStore((state) => [state.getLocalText])
  const vinValidationList = getSystemSetting('VIN3_VALIDATION') as ISystemSetting
  const initialGroundingValue = {
    vehicleReturnDate: groundingData.vehicleReturnDate && new Date(groundingData.vehicleReturnDate),
    currentVIN: '',
    odometerReading: groundingData?.odometerReading.toString(),
    confirmOdometerReading: groundingData?.odometerConfirm.toString(),
    newVIN: groundingData?.newLeaseVIN,
    newBrand: groundingData?.newVehicleBrand,
    requiresNewVIN: groundingData?.requiresNewVin,
    requiresNewVINNotBrand: groundingData?.requiresNewVINNotBrand,
    requiresNewVINForCampaign: groundingData?.requiresNewVINForCampaign,
    vinValidationList: vinValidationList,
    campaign: groundingData.SelectedCampaignId
  }
  const [isLoading, setIsLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [formErrors, setFormErrors] = useState(null)
  const [attributesValue, setAttributesValue] = useState<DropDownGroup[]>(groundingData?.attributes)
  const [odometerOptionSelected, setOdometerOptionSelected] = useState(groundingData?.odometerOptionSelected)
  const [performPurchase, setPerformPurchase] = useState(
    groundingData?.performPurchase !== undefined ? groundingData?.performPurchase : true
  )
  const [isInvalidNewVIN, setIsInvalidNewVIN] = useState(false)

  const [initValue, setInitValue] = useState<IGroundingForm>(initialGroundingValue)
  const [showCreditConfirmModal, setShowCreditConfirmModal] = useState(false)
  let minMilesValue = groundingData?.MinMiles ?? 0
  if (
    groundingData?.MinMiles !== undefined &&
    groundingData?.MinMiles > 0 &&
    groundingData?.MinMiles < groundingData?.CRMileage
  ) {
    minMilesValue = 0
  }
  const maxMilesValue = groundingData?.MaxMiles ?? 0
  const minOdometerValue = groundingData?.MinFinalMileage ? groundingData?.MinFinalMileage - 1 : 0
  const maxOdometerValue = groundingData?.MaxFinalMileage ? groundingData?.MaxFinalMileage + 1 : 0
  const [isEditAddress, setIsEditAddress] = useState(false)
  const [isSaveAddressToBuyer, setIsSaveAddressToBuyer] = useState(true)
  const [locationSelected, setLocationSelected] = useState(
    groundingData?.selectedAddress === 0 ? groundingData?.locations[0].ID : groundingData?.selectedAddress
  )
  const [initLocations, setInitLocations] = useState<LocationDropDown[]>(
    groundingData?.initLocations === undefined ? groundingData?.locations.slice(0, -1) : groundingData?.initLocations
  )
  const [indicationOptionSelected, setIndicationOptionSelected] = useState<GroundingIndication>(
    groundingData?.indications.find((x) => x.ID === groundingData?.selectedIndication) ?? null
  )
  const [isLowerMileageLastInspection, setIsLowerMileageLastInspection] = useState(false)
  const [dispositionsValue, setDispositionsValue] = useState<GroundingDispositionData[]>(groundingData?.dispositions)
  const [groundingDispositionSelected, setGroundingDispositionSelected] = useState<GroundingDispositionData>(
    groundingData?.groundingDispositionSelected
  )
  const [selectedDispostionID, setSelectedDispostionID] = useState(groundingData?.selectedDisposition)
  const [alertMessage] = useState(groundingData?.alertMessage)
  const [confirmText, setConfirmText] = useState('')
  const [isOpenRecall, setIsOpenRecall] = useState(false)

  const [currentPrice, setCurrentPrice] = useState(groundingData?.purchasePrice)
  const [currentPriceString, setCurrentPriceString] = useState(groundingData?.purchasePriceString)
  const [encryptedPurchasePrice, setEncryptedPurchasePrice] = useState(groundingData?.encryptedPurchasePrice)
  const [buyerFee, setBuyerFee] = useState(groundingData?.buyerFee)
  const [buyerFeeString, setBuyerFeeString] = useState(groundingData?.buyerFeeString)
  const [payoffAuthorizationCompleted, setPayoffAuthorizationCompleted] = useState(
    groundingData?.payoffAuthorizationCompleted !== undefined ? groundingData?.payoffAuthorizationCompleted : true
  )
  const [selectedCampaignId, setSelectedCampaignId] = useState(groundingData?.SelectedCampaignId)
  const [selectedCampaign, setSelectedCampaign] = useState<Campaign>(groundingData?.SelectedCampaign)
  const [validCampaignsForGrounding, setValidCampaignsForGrounding] = useState(
    groundingData?.validCampaignsForGrounding ?? []
  )

  const [showRecallModal, setShowRecallModal] = useState(false)
  const [showGeneralModal, setShowGeneralModal] = useState(false)
  const [showConfirmOdometer, setShowConfirmOdometer] = useState(false)
  const [showAddressModal, setShowAddressModal] = useState(false)

  const [showErrorMessage, setShowErrorMessage] = useState(false)
  const [today, setToday] = useState<Date>(null)
  const confirmationText = getLocalText(
    'Confirm_Payoff_Authorization',
    'The customer’s credit in the amount of %AMOUNT% has been applied to the purchase price of the vehicle.  Is the Payoff Authorization form complete?'
  )

  const confirmOdoStatement = getLocalText(
    'Confirm_Odo_Statement',
    'YOU HAVE INDICATED THAT THERE IS A PROBLEM WITH THE ODOMETER OF THIS VEHICLE. AS A RESULT, THIS VEHICLE WILL NOT BE MADE AVAILABLE FOR SALE. IS THIS CORRECT?'
  )
  const history = useHistory()
  const formRef = useRef<FormikProps<FormikValues>>(null)
  const [isMileageOptionNeedConfirm, setIsMileageOptionNeedConfirm] = useState(false)

  useEffect(() => {
    let initSchemaValue = initValue
    initSchemaValue.currentVIN = groundingData?.VIN
    if (groundingData?.MaxBackdateDays === 0 || groundingData?.MaxBackdateDays === undefined) {
      initSchemaValue.vehicleReturnDate = new Date(groundingData?.groundingDate)
    }
    setInitValue(initSchemaValue)
  }, [groundingData?.VIN, initLocations, initValue])

  useEffect(() => {
    if (groundingData?.dispositions.length === 1 && groundingDispositionSelected === undefined) {
      setGroundingDispositionSelected(groundingData?.dispositions[0])
      groundingData.purchasePrice = groundingData?.dispositions[0].PurchasePrice
      groundingData.purchasePriceString = groundingData?.dispositions[0].PurchasePriceString
      setGroundingData(groundingData)
      setCurrentPrice(groundingData?.dispositions[0].PurchasePrice)
      setCurrentPriceString(groundingData?.dispositions[0].PurchasePriceString)
      setEncryptedPurchasePrice(groundingData?.dispositions[0].EncryptedPurchasePrice)
      setBuyerFee(groundingData?.dispositions[0].BuyerFee)
      setBuyerFeeString(groundingData?.dispositions[0].BuyerFeeString)
    }

    // Recall logic
    const hasOpenRecall =
      groundingData?.RecallCollection &&
      Number(groundingData?.RecallCollection?.RecallStatusType) === RecallDetailStatus.HasOpenRecall
    setIsOpenRecall(hasOpenRecall)
    if (
      alertMessage !== undefined &&
      alertMessage !== null &&
      (alreadyConfirmGeneralModal === false || alreadyConfirmGeneralModal === undefined)
    ) {
      setConfirmText(alertMessage)
      setShowGeneralModal(true)
    } else {
      if (hasOpenRecall && (alreadyConfirmRecall === false || alreadyConfirmRecall === undefined)) {
        setShowRecallModal(true)
      }
    }

    // handleCampaignData(new Date(groundingData?.vehicleReturnDate))

    //Terms and Conditions link logic
    const link = document.getElementById('termsLink')
    if (link) {
      link.addEventListener('click', handleClick)
    }

    return () => {
      // Cleanup function to remove event listener
      if (link) {
        link.removeEventListener('click', handleClick)
      }
    }
  }, [])

  useEffect(() => {
    if (!isSubmit) return
    handleReviewSubmitButtonClicked()
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }, [isSubmit])

  const showIndications = useMemo(() => {
    return (
      groundingData?.indications.length > 0 &&
      (groundingDispositionSelected?.ID === DispositionOption.LESSEE_RETURN ||
        groundingDispositionSelected?.ID === DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT) &&
      !selectedCampaign?.IsPullAhead
    )
  }, [groundingData, groundingDispositionSelected, selectedCampaign])

  const hasError = useMemo(
    () =>
      Boolean(
        groundingDispositionSelected === null ||
          groundingDispositionSelected === undefined ||
          (showIndications && indicationOptionSelected === null) ||
          odometerOptionSelected < 0 ||
          odometerOptionSelected === undefined ||
          attributesValue.some(
            (x) => x.IsRequired && (x.selectedID === undefined || x.selectedID === null || x.selectedID?.ID < 0)
          ) ||
          locationSelected === 0 ||
          selectedCampaignId === -1
      ),
    [
      odometerOptionSelected,
      groundingDispositionSelected,
      locationSelected,
      showIndications,
      indicationOptionSelected,
      attributesValue,
      selectedCampaignId
    ]
  )

  const handleClick = (event) => {
    event.preventDefault() // Prevent default navigation
    setShowTerms(true)
  }

  const isCheckMaximumOdometer = 1

  const resetPriceForDispOption16And17 = () => {
    const newDispositions = [...dispositionsValue]
    newDispositions.forEach((disposition) => {
      if (
        disposition.ID === DispositionOption.LESSEE_PURCHASE ||
        disposition.ID === DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT
      ) {
        disposition.PurchasePrice = disposition.CopyPurchasePrice
        disposition.PurchasePriceString = disposition.CopyPurchasePriceString
      }
    })
    setDispositionsValue(newDispositions)
  }

  const handleConfirmPayoff = () => {
    resetPriceForDispOption16And17()
    if (groundingDispositionSelected.PurchasePrice) {
      groundingData.purchasePrice = groundingDispositionSelected.PurchasePrice
      groundingData.purchasePriceString = groundingDispositionSelected.PurchasePriceString
      setGroundingData(groundingData)
      setCurrentPrice(groundingDispositionSelected.PurchasePrice)
      setCurrentPriceString(groundingDispositionSelected.PurchasePriceString)
      setEncryptedPurchasePrice(groundingDispositionSelected.EncryptedPurchasePrice)
      setBuyerFee(groundingDispositionSelected.BuyerFee)
      setBuyerFeeString(groundingDispositionSelected.BuyerFeeString)
    }
    setShowCreditConfirmModal(false)
    setPayoffAuthorizationCompleted(true)
  }

  const handleRejectPayoff = () => {
    let newDispositions = [...dispositionsValue]
    newDispositions.forEach((disposition) => {
      if (disposition.ID === groundingDispositionSelected.ID) {
        disposition.PurchasePrice = disposition.CreditPurchasePrice
        disposition.PurchasePriceString = disposition.CreditPurchasePriceString
      } else {
        disposition.PurchasePrice = disposition.CopyPurchasePrice
        disposition.PurchasePriceString = disposition.CopyPurchasePriceString
      }
    })
    setDispositionsValue(newDispositions)
    groundingData.purchasePrice = groundingDispositionSelected.PurchasePrice
    groundingData.purchasePriceString = groundingDispositionSelected.PurchasePriceString
    setGroundingData(groundingData)
    setCurrentPrice(groundingDispositionSelected.PurchasePrice)
    setCurrentPriceString(groundingDispositionSelected.PurchasePriceString)
    setEncryptedPurchasePrice(groundingDispositionSelected.EncryptedPurchasePrice)
    setBuyerFee(groundingDispositionSelected.BuyerFee)
    setBuyerFeeString(groundingDispositionSelected.BuyerFeeString)
    setShowCreditConfirmModal(false)
    setPayoffAuthorizationCompleted(false)
  }

  const handleResetPayoff = () => {
    resetPriceForDispOption16And17()
    groundingData.purchasePrice = 0
    groundingData.purchasePriceString = ''
    setGroundingData(groundingData)
    setCurrentPrice(0)
    setCurrentPriceString('')
    setBuyerFee(0)
    setBuyerFeeString('')
    setGroundingDispositionSelected(null)
    setShowCreditConfirmModal(false)
    setPayoffAuthorizationCompleted(true)
  }

  const handleGroundingOptionChange = (dispositonOptionIndex: number) => {
    setIndicationOptionSelected(null)
    const currentDispositon = groundingData?.dispositions[dispositonOptionIndex]
    setSelectedDispostionID(currentDispositon.ID)
    setGroundingDispositionSelected(currentDispositon)
    groundingData.purchasePrice = currentDispositon.PurchasePrice
    groundingData.purchasePriceString = currentDispositon.PurchasePriceString
    groundingData.selectedNoSignReason = 0
    for (const signatureType of groundingData?.signatureTypes) {
      signatureType.SelectedNoSignReason = 0
    }
    setGroundingData(groundingData)
    setCurrentPrice(currentDispositon.PurchasePrice)
    setCurrentPriceString(currentDispositon.PurchasePriceString)
    setEncryptedPurchasePrice(currentDispositon.EncryptedPurchasePrice)
    setBuyerFee(currentDispositon.BuyerFee)
    setBuyerFeeString(currentDispositon.BuyerFeeString)
    if (groundingData?.creditBalanceFlag === 'N') {
      return
    }
    if (
      (currentDispositon.ID === DispositionOption.LESSEE_PURCHASE ||
        currentDispositon.ID === DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT) &&
      groundingData
    ) {
      setShowCreditConfirmModal(true)
    } else {
      resetPriceForDispOption16And17()
      setPayoffAuthorizationCompleted(false)
    }
  }

  const handleIndicationOptionChange = (indicationOptionId: number) => {
    setIndicationOptionSelected(groundingData?.indications.find((x) => x.ID === indicationOptionId))
  }

  const handleAttributeChange = (id: number, index: number) => {
    const newAttributes = attributesValue.map((attribute, idx) => {
      if (idx === index) {
        return {
          ...attribute,
          selectedID: attribute.attributeSelections.find((x) => x.ID === id)
        }
      }
      return attribute
    })
    setAttributesValue(newAttributes)
  }

  const handleOdometerOptionChange = (odometerOptionId: number) => {
    setOdometerOptionSelected(odometerOptionId)
    if (
      (odometerOptionId === 2 || odometerOptionId === 3) &&
      groundingData?.odometerStatements.find((x) => x.ID === odometerOptionId)?.FieldDescription === 'Y'
    ) {
      setIsMileageOptionNeedConfirm(true)
      setPerformPurchase(false)
    } else {
      setPerformPurchase(true)
    }
  }

  const handleBlurOdometer = (e: any) => {
    const odometerInputValue = e.target.value

    if (
      (odometerInputValue !== '' &&
        Number(odometerInputValue) > minOdometerValue &&
        Number(odometerInputValue) < minMilesValue) ||
      (isCheckMaximumOdometer &&
        Number(odometerInputValue) < maxOdometerValue &&
        Number(odometerInputValue) > maxMilesValue)
    ) {
      if (Number(odometerInputValue) < groundingData?.CRMileage) {
        setIsLowerMileageLastInspection(true)
      }
      setShowConfirmOdometer(true)
    } else {
      setShowConfirmOdometer(false)
    }
  }

  const updateLocations = (address: IAddress, addressDescription: string) => {
    setInitLocations((x) =>
      x.map((location) => {
        if (location.ID === locationSelected) {
          return {
            ...location,
            Description: addressDescription,
            Address1: address.AddressLineOne,
            Address2: address.AddressLineTwo,
            City: address.Town,
            State: groundingData?.states?.find((x) => x.ID === address.StateId)?.FieldDescription,
            StateCode: groundingData?.states?.find((x) => x.ID === address.StateId)?.FieldDescription,
            Zip: address.PostCode
          }
        }
        return location
      })
    )
  }

  const addLocations = (address: IAddress, addressDescription: string, addressId: number) => {
    setInitLocations((currentList) => [
      {
        ID: addressId,
        Description: addressDescription,
        Address1: address.AddressLineOne,
        Address2: address.AddressLineTwo,
        City: address.Town,
        State: groundingData?.states?.find((x) => x.ID === address.StateId)?.Description,
        StateCode: groundingData?.states?.find((x) => x.ID === address.StateId)?.FieldDescription,
        Zip: address.PostCode,
        AddressTypeID: address.AddressTypeId
      },
      ...currentList
    ])
    setLocationSelected(addressId)
  }

  const handleShowAddressModal = (isEdit: boolean) => {
    setShowAddressModal(true)
    setIsEditAddress(isEdit)
  }

  const handleSaveAddress = async (address: IAddress) => {
    try {
      setShowAddressModal(false)
      setIsLoading(true)

      const result = await saveAddress({
        Address: address,
        SaveToBuyer: isSaveAddressToBuyer
      })

      if (result > 0) {
        const addressDescription =
          address.AddressLineOne +
          `${address.AddressLineTwo !== '' ? ', ' + address.AddressLineTwo : ''}` +
          ', ' +
          address.Town +
          ', ' +
          groundingData?.states?.find((x) => x.ID === address.StateId)?.FieldDescription +
          ' ' +
          address.PostCode

        if (isEditAddress && address.AddressId != 0) {
          updateLocations(address, addressDescription)
        } else {
          addLocations(address, addressDescription, result)
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleReviewSubmitButtonClicked = () => {
    setIsValidate(true)
    if (
      hasError === true ||
      formValues?.vehicleReturnDate === null ||
      formValues?.odometerReading <= minOdometerValue ||
      formErrors?.newVIN !== null ||
      selectedCampaignId === -1 ||
      (isCheckMaximumOdometer && Number(formValues?.odometerReading) >= maxOdometerValue)
    ) {
      setShowErrorMessage(true)
      window.scrollTo(0, 0)
      setIsSubmit(false)
    }
  }

  const handleReviewSubmit = (values: any) => {
    if (
      hasError === true ||
      values.vehicleReturnDate === null ||
      Number(values.odometerReading) <= minOdometerValue ||
      (isCheckMaximumOdometer && Number(values.odometerReading) >= maxOdometerValue)
    ) {
      return
    }
    updateGroundingData(values)
    setActiveStep(GroundingRenderStep.GRD_TURN_IN)
    setIsSubmit(false)
    setIsLoading(false)
  }

  const updateGroundingData = (formValues: IGroundingForm) => {
    if (groundingData) {
      let newGroundingData = JSON.parse(JSON.stringify(groundingData))
      newGroundingData.DealerID = CurrentBuyerID
      newGroundingData.buyerAddress = groundingData.locations.find((x) => x.ID === locationSelected)?.Address1 ?? ''
      newGroundingData.buyerAddress2 = groundingData.locations.find((x) => x.ID === locationSelected)?.Address2 ?? ''
      newGroundingData.buyerCity = groundingData.locations.find((x) => x.ID === locationSelected)?.City ?? ''
      newGroundingData.buyerState = groundingData.locations.find((x) => x.ID === locationSelected)?.State ?? ''
      newGroundingData.buyerZip = groundingData.locations.find((x) => x.ID === locationSelected)?.Zip ?? ''
      newGroundingData.selectedAddress = locationSelected
      newGroundingData.initLocations = initLocations
      newGroundingData.selectedOdometerStatement = groundingData.odometerStatements.find(
        (x) => x.ID === odometerOptionSelected
      )?.Description
      newGroundingData.odometerOptionSelected = odometerOptionSelected
      newGroundingData.vehicleReturnDate = formValues.vehicleReturnDate.toLocaleDateString()
      newGroundingData.odometerReading = Number(formValues.odometerReading)
      newGroundingData.odometerConfirm = Number(formValues.confirmOdometerReading)
      newGroundingData.newLeaseVIN = formValues.newVIN
      newGroundingData.newVehicleBrand = formValues.newBrand

      newGroundingData.selectedIndication = indicationOptionSelected?.ID
      newGroundingData.groundingDispositionSelected = groundingDispositionSelected
      newGroundingData.selectedDisposition = selectedDispostionID
      newGroundingData.attributes = attributesValue
      newGroundingData.payoffAuthorizationCompleted = payoffAuthorizationCompleted
      if (groundingData?.dispositions.find((x) => x.ID === DispositionOption.DEALER_INVENTORY_PURCHASE)) {
        newGroundingData.canPurchaseVehicleInGESaleChannel = true
      } else {
        newGroundingData.canPurchaseVehicleInGESaleChannel = false
      }
      newGroundingData.performPurchase = performPurchase
      newGroundingData.purchasePrice = currentPrice
      newGroundingData.purchasePriceString = currentPriceString
      newGroundingData.encryptedPurchasePrice = encryptedPurchasePrice
      newGroundingData.buyerFee = buyerFee
      newGroundingData.buyerFeeString = buyerFeeString
      newGroundingData.SelectedCampaignId = selectedCampaignId
      newGroundingData.SelectedCampaign = selectedCampaign
      newGroundingData.validCampaignsForGrounding = validCampaignsForGrounding
      newGroundingData.requiresNewVin = formValues.requiresNewVIN
      newGroundingData.requiresNewVINNotBrand = formValues.requiresNewVINNotBrand
      newGroundingData.requiresNewVINForCampaign = formValues.requiresNewVINForCampaign
      setGroundingData(newGroundingData)
    }
  }

  const handleCampaignData = (returnDate: string) => {
    let hasData: boolean = false
    setValidCampaignsForGrounding([])
    setSelectedCampaignId(0)
    if (groundingData?.Campaigns && groundingData?.Campaigns.length > 0) {
      groundingData?.Campaigns.forEach((campaign) => {
        const startDate = new Date(campaign.StartDate)
        const endDate = new Date(campaign.EndDate)
        const newReturnDate = new Date(returnDate)
        const gracePeriodDate = addDays(endDate, groundingData?.gracePeriod)
        const currentDate = new Date()
        if (newReturnDate >= startDate && newReturnDate <= endDate) {
          if (currentDate >= startDate && currentDate <= gracePeriodDate) {
            hasData = true
            setValidCampaignsForGrounding((prev) => {
              return [...prev, campaign]
            })
          }
        }
      })
      if (hasData) {
        setSelectedCampaignId(-1)
        setValidCampaignsForGrounding((prev) => {
          return [...prev, groundingData?.Campaigns[groundingData?.Campaigns.length - 1]]
        })
      }
    }
  }

  const handleCampaignOptionChange = (campaignID: number) => {
    setSelectedCampaignId(campaignID)
    setToday(null)
    setSelectedCampaign(groundingData?.Campaigns.find((campaign) => campaign.ID === campaignID))
  }

  const computedAcknowledgeBlock = function (textToUpdate: string, currentPurchasePriceString: string) {
    return textToUpdate && textToUpdate.replace('%AMOUNT%', currentPurchasePriceString)
  }

  const saveFormErrors = (values) => {
    setFormErrors(values)
  }

  const FormErrorContext = () => {
    const formik = useFormikContext()
    useEffect(() => {
      saveFormErrors(formik.errors)
      setFormValues(formik.values)
    }, [formik.errors, formik.values])
    return null
  }

  return (
    <StyledGroundingOptions>
      {isLoading && <OverlayLoader />}
      <GroundingVehicleDetails />
      <Formik
        enableReinitialize
        initialValues={initValue}
        validationSchema={groundingValueValidateSchema(initValue)}
        validateOnBlur={true}
        innerRef={formRef}
        onSubmit={(values) => {
          setFormValues(values)
          handleReviewSubmit(values)
        }}
      >
        {(props) => (
          <Form>
            <p>Grounding Completion Date: {groundingData?.groundingDate}</p>
            <Row className="mt-5">
              <Col lg={{ span: 4 }} sm={{ span: 8 }}>
                {showErrorMessage && (
                  <Alert
                    className="col-6 col-lg-8 col-sm-8"
                    variant="danger"
                    onClose={() => setShowErrorMessage(false)}
                    dismissible
                  >
                    {'Please review errors and resubmit'}
                  </Alert>
                )}
              </Col>
            </Row>
            <StyledGroundingOption>
              <DividerWidthText title="Grounding Options" />
              {groundingData?.MaxBackdateDays > 0 && (
                <>
                  <div className="date-picker">
                    <div>
                      <StyledLabelRequired className="required-field date-label">
                        Vehicle Return Date
                      </StyledLabelRequired>
                    </div>

                    <div className="date-input">
                      <StyledDatePickerWithIcon>
                        <span className="dateInput">
                          <DateTimePicker
                            name="vehicleReturnDate"
                            popperPlacement="bottom"
                            minDate={new Date(groundingData?.minReturnDate)}
                            maxDate={new Date()}
                            selected={props.values.vehicleReturnDate}
                            onBlur={() => {
                              props.setFieldTouched('vehicleReturnDate')
                            }}
                            onFocus={(event: any) => {
                              if (event.target.value === '') {
                                props.setFieldTouched('vehicleReturnDate')
                                var date = new Date()
                                props.setFieldValue('vehicleReturnDate', date)
                                props.setFieldValue('requiresNewVINForCampaign', false)
                                setToday(date)
                                handleCampaignData(date.toString())
                              }
                            }}
                            onChange={(value: any) => {
                              props.setFieldTouched('vehicleReturnDate')
                              props.setFieldValue('vehicleReturnDate', value)
                              props.setFieldValue('requiresNewVINForCampaign', false)
                              handleCampaignOptionChange(-1)
                              handleCampaignData(value)
                            }}
                            format="MM/dd/yyyy"
                          />
                        </span>
                        <span className="icon">
                          <Calendar></Calendar>
                        </span>
                      </StyledDatePickerWithIcon>
                      <p className="error-label">
                        {isValidate && !!props.errors?.vehicleReturnDate && props.errors.vehicleReturnDate}
                      </p>
                    </div>
                  </div>
                </>
              )}
              {validCampaignsForGrounding?.length > 0 && (
                <>
                  <h4 className="campaign-title">Attention</h4>
                  <div className="option-confirm">
                    <p>
                      This vehicle is available for the following program(s). Please indicate which program the customer
                      will participate in:
                    </p>
                    {validCampaignsForGrounding?.map((item, index) => (
                      <div key={'campaign-option-' + index} className="pull-ahead">
                        <p className="error-label">{(selectedCampaignId === -1 || today) && 'Required'}</p>
                        <label className="radio-button">
                          <Field
                            type="radio"
                            name="campaign"
                            id={'campaign-option-' + index}
                            checked={selectedCampaignId === item?.ID}
                            onChange={(e) => {
                              props.values.newVIN = ''
                              props.handleChange(e)
                              if (groundingData?.Campaigns.find((campaign) => campaign.ID === item.ID)?.IsPullAhead) {
                                props.setFieldValue('requiresNewVINForCampaign', true)
                              } else {
                                props.setFieldValue('requiresNewVINForCampaign', false)
                              }
                              handleCampaignOptionChange(item.ID)
                            }}
                          />
                          <span className="radio-checkmark"></span>
                          <strong>
                            <label htmlFor={'campaign-option-' + index}>{item?.Title}</label>
                          </strong>
                        </label>
                        <div className="program-info-desc">{item?.Description}</div>
                        {selectedCampaignId === 0 && item?.ID !== 0 && item?.IsPullAhead && (
                          <div className="program-info">
                            <span className="has-error">Customer will not be participating in Pull Ahead Program</span>
                          </div>
                        )}
                        {selectedCampaignId === 0 && item?.ID !== 0 && item?.IsPullAhead === false && (
                          <div className="program-info">
                            <span className="has-error">Customer will not be participating in Marketing Program</span>
                          </div>
                        )}
                        {selectedCampaignId === item?.ID && item?.ID !== 0 && item?.IsPullAhead && (
                          <div className="program-info">
                            <span>Customer indicated they are participating in the pull ahead program</span>
                          </div>
                        )}
                        {selectedCampaignId === item?.ID && item?.ID !== 0 && item?.IsPullAhead === false && (
                          <div className="program-info">
                            <span>Customer indicated they are participating in the marketing program</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="error-label">{isValidate && odometerOptionSelected < 0 && 'Please select an option'}</p>
                  {selectedCampaign?.IsPullAhead && (
                    <>
                      <h5>Enter VIN of New Lease Vehicle</h5>
                      <Row style={{ marginTop: '20px' }} className="left-field new-vin">
                        <Col lg={2}>
                          <label className="required-field">{'New Vehicle VIN #'}</label>
                        </Col>

                        <Col lg={3}>
                          <Input
                            name="newVIN"
                            placeholder="#17 digit VIN"
                            // isInvalid={isSubmit && !!props.errors?.newVIN}
                            onChange={(e) => {
                              props.values.newBrand = ''
                              props.handleChange(e)
                              setIsInvalidNewVIN(false)
                            }}
                            maxLength={17}
                            value={props.values?.newVIN}
                          />
                          {/* {!isInvalidNewVIN && ( */}
                          <p className="error-label">{!!props.errors?.newVIN && props.errors.newVIN}</p>
                          {/* )} */}
                        </Col>
                      </Row>
                    </>
                  )}
                  <h4 className="disposition-title">Select a Disposition</h4>
                </>
              )}
              {groundingData?.ShowDisposition && (
                <>
                  <Row>
                    {dispositionsValue?.map((item, index) => (
                      <div key={'disposition' + index} className="grounding-data-option">
                        <label className="radio-button">
                          <Field
                            type="radio"
                            name="disposition"
                            checked={item.ID === groundingDispositionSelected?.ID}
                            //   value={item.RequiresNewVIN.toString() + index}
                            id={'disposition' + index}
                            onChange={(e) => {
                              props.handleChange(e)
                              handleGroundingOptionChange(index)
                              props.setFieldValue('requiresNewVIN', false)
                              props.setFieldValue('requiresNewVINNotBrand', false)
                            }}
                          />
                          <span className="radio-checkmark"></span>
                        </label>
                        <div className="purchase-content">
                          <label htmlFor={'disposition' + index} style={{ fontWeight: 'bold' }}>
                            {item.Description}
                          </label>
                          <div className="purchase-price">{item.PurchasePriceString}</div>
                          {(selectedCampaign?.IsPullAhead === false || selectedCampaign?.IsPullAhead === undefined) && (
                            <div dangerouslySetInnerHTML={{ __html: item.DispositionNote }}></div>
                          )}
                          {selectedCampaign?.IsPullAhead && item.PurchasePriceString && (
                            <div>
                              (Purchase price is based on customer term type. If purchased at residual, the customer may
                              receive a liability statement, but it will not contain excess wear/use and mileage
                              charges.)
                            </div>
                          )}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: computedAcknowledgeBlock(
                                item?.FieldDescription,
                                dispositionsValue[index]?.PurchasePriceString
                              )
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </Row>
                  <p className="error-label">
                    {isValidate &&
                      (groundingDispositionSelected === undefined || groundingDispositionSelected === null) &&
                      GENERAL_ERROR_MESSAGE}
                  </p>
                </>
              )}
              {showIndications && (
                <Row>
                  <Col sm={12}>
                    {groundingDispositionSelected?.ID === DispositionOption.LESSEE_RETURN && (
                      <label style={{ textTransform: 'uppercase' }}>{GND_DISPOSITION_RETURN_CONFIRM}</label>
                    )}
                    {groundingDispositionSelected?.ID ===
                      DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT && (
                      <label style={{ textTransform: 'uppercase' }}>{GND_DISPOSITION_PURCHASE_CONFIRM}</label>
                    )}
                    {groundingData?.indications
                      ?.filter((x) => Number(x.DispositionTypeID) === groundingDispositionSelected?.ID)
                      .map((item, index) => (
                        <Row className="indication-row">
                          <Col sm={6} lg={3}>
                            <div key={'indication' + index} className="indication-radio">
                              <label className="radio-button">
                                <Field
                                  type="radio"
                                  name="requiresNewVIN"
                                  checked={item.ID === indicationOptionSelected?.ID}
                                  value={item.RequiresNewVIN.toString()}
                                  id={'indication' + index}
                                  onChange={(e) => {
                                    props.values.newBrand = ''
                                    props.values.newVIN = ''
                                    props.handleChange(e)
                                    handleIndicationOptionChange(item.ID)
                                    if (item.IndicationDetail !== 'Customer will lease/buy another brand') {
                                      props.setFieldValue('requiresNewVINNotBrand', true)
                                    } else props.setFieldValue('requiresNewVINNotBrand', false)
                                  }}
                                />
                                <span className="radio-checkmark"></span>
                              </label>
                              <label htmlFor={'indication' + index}> {item.IndicationDetail}</label>
                            </div>
                          </Col>
                          {indicationOptionSelected?.RequiresNewVIN && indicationOptionSelected.ID === item.ID && (
                            <Col sm={6} lg={5}>
                              <Row>
                                <Col lg={3}>
                                  <label className={indicationOptionSelected.IsRequiredField && 'required-field'}>
                                    {indicationOptionSelected.IndicationDetail ===
                                    'Customer will lease/buy another brand'
                                      ? 'NEW VEHICLE BRAND'
                                      : 'NEW VEHICLE VIN #'}
                                  </label>
                                </Col>
                                {indicationOptionSelected.RequiresNewVIN &&
                                indicationOptionSelected.IndicationDetail !==
                                  'Customer will lease/buy another brand' ? (
                                  <Col lg={6}>
                                    <Input
                                      name="newVIN"
                                      placeholder="#17 digit VIN"
                                      isInvalid={isValidate && !!props.errors?.newVIN}
                                      onChange={(e) => {
                                        // handleNisOrInfinitiVIN(e)
                                        props.values.newBrand = ''
                                        props.handleChange(e)
                                        props.values.requiresNewVIN = indicationOptionSelected?.RequiresNewVIN
                                        props.values.requiresNewVINNotBrand = true
                                        setIsInvalidNewVIN(false)
                                      }}
                                      maxLength={17}
                                      value={props.values?.newVIN}
                                    />
                                    <p className="error-label">{!!props.errors?.newVIN && props.errors.newVIN}</p>
                                  </Col>
                                ) : (
                                  <Col lg={7}>
                                    <Input
                                      name="newBrand"
                                      isInvalid={isValidate && !!props.errors?.newBrand}
                                      onChange={(e) => {
                                        props.values.newVIN = ''
                                        props.handleChange(e)
                                        props.values.requiresNewVIN = indicationOptionSelected?.RequiresNewVIN
                                        props.values.requiresNewVINNotBrand = false
                                      }}
                                      maxLength={17}
                                      value={props.values?.newBrand}
                                    />
                                    {/* {!isInvalidNewVIN && ( */}
                                    <p className="error-label">{!!props.errors?.newBrand && props.errors.newBrand}</p>
                                    {/* )} */}
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          )}
                        </Row>
                      ))}
                    <p className="error-label">
                      {isValidate &&
                        (indicationOptionSelected === undefined || indicationOptionSelected === null) &&
                        GENERAL_ERROR_MESSAGE}
                    </p>
                  </Col>
                </Row>
              )}
            </StyledGroundingOption>
            <StyledGroundingOdometer>
              <DividerWidthText title="Enter Final Odometer Reading" />
              <Row className="odometer-input">
                <Col className="col-xxl-2 col-xl-2 col-lg-2 col-12">
                  <StyledLabelRequired className="required-field">Odometer Reading</StyledLabelRequired>
                </Col>
                <Col className="col-xxl-2 col-xl-4 col-lg-4 col-12">
                  <Input
                    name="odometerReading"
                    // isInvalid={!!props.errors?.odometerReading}
                    onChange={(e) => {
                      props.handleChange(e)
                      //   handleOdometerInputChange()
                    }}
                    placeholder="No tenths"
                    value={props.values?.odometerReading === '0' ? '' : props.values?.odometerReading}
                    onBlur={(e) => {
                      handleBlurOdometer(e)
                      props.handleBlur(e)
                    }}
                  />
                  {!showConfirmOdometer && (
                    <p className="error-label">
                      {props.touched.odometerReading && !!props.errors?.odometerReading && props.errors.odometerReading}
                      {props.touched.odometerReading &&
                        !props.errors?.odometerReading &&
                        (Number(props.values.odometerReading) === 0
                          ? GENERAL_ERROR_MESSAGE
                          : Number(props.values.odometerReading) <= minOdometerValue
                          ? 'The odometer reading is not valid.'
                          : null)}
                      {props.touched.odometerReading &&
                        !props.errors?.odometerReading &&
                        isCheckMaximumOdometer === 1 &&
                        Number(props.values.odometerReading) >= maxOdometerValue &&
                        ERROR_ODOMETER_INVALID_INPUT}
                    </p>
                  )}
                </Col>
                <Col className="col-xxl-2 offset-xxl-1 col-xl-2 col-lg-2 col-12">
                  <StyledLabelRequired className="required-field">Confirm Odometer Reading</StyledLabelRequired>
                </Col>
                <Col className="col-xxl-2 col-xl-4 col-lg-4  col-12">
                  <Input
                    className="confirm-odo-input"
                    name="confirmOdometerReading"
                    onChange={(e) => {
                      props.handleChange(e)
                    }}
                    onBlur={props.handleBlur}
                    placeholder="No tenths"
                    value={props.values?.confirmOdometerReading === '0' ? '' : props.values?.confirmOdometerReading}
                  />
                  <p className="error-label">
                    {props.touched.confirmOdometerReading &&
                      !!props.errors?.confirmOdometerReading &&
                      props.errors.confirmOdometerReading}
                  </p>
                </Col>
                {/* </Row>
                </Col> */}
              </Row>
              <div className="option-confirm mb-4">
                <p className="required-field">I hereby certify that, to the best of my knowledge</p>
                {groundingData?.odometerStatements?.map((item, index) => (
                  <div className="option">
                    <label className="radio-button">
                      <input
                        type="radio"
                        name="odometer"
                        id={'odometer-option-' + index}
                        checked={odometerOptionSelected === item.ID}
                        onChange={() => handleOdometerOptionChange(item.ID)}
                      />
                      <span className="radio-checkmark"></span>
                    </label>
                    <label htmlFor={'odometer-option-' + index}>{item.Description}</label>
                  </div>
                ))}
                <p className="error-label">
                  {isValidate &&
                    (odometerOptionSelected === undefined || odometerOptionSelected === -1) &&
                    GENERAL_ERROR_MESSAGE}
                </p>
              </div>
            </StyledGroundingOdometer>
            {groundingData?.attributes.length > 0 && (
              <StyledGroundingItem>
                <Row className="mt-3 mb-4">
                  <div className="grounding-item-container">
                    <DividerWidthText title="Quantity of items returned with the vehicle" />
                    <Row>
                      {groundingData?.attributes?.map((attribute, index) => (
                        <Col sm={6} md={4}>
                          <div className="grounding-item">
                            <span className={attribute.IsRequired && 'required-field'}>{attribute.Description}</span>
                            <DropdownList
                              defaultValue={attribute.selectedID ? attribute.selectedID.ID.toString() : '-1'}
                              items={attribute.attributeSelections?.map((item) => ({
                                id: item?.ID?.toString(),
                                value: item?.Description
                              }))}
                              onChange={(id) => handleAttributeChange(Number(id), index)}
                            />
                          </div>
                          <p className="error-label">
                            {isValidate &&
                              attribute.IsRequired &&
                              (!attributesValue.find((x) => x.Description === attribute.Description).selectedID ||
                                attributesValue.find((x) => x.Description === attribute.Description).selectedID.ID <
                                  0) &&
                              GENERAL_ERROR_MESSAGE}
                          </p>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Row>
              </StyledGroundingItem>
            )}
            <StyledGroundingAdditional>
              <DividerWidthText title="Additional Information" />
              <Row className="mt-3">
                <Col lg={2}>
                  <StyledLabelRequired className="required-field">Vehicle Location</StyledLabelRequired>
                </Col>
                <Col sm={8} lg={3}>
                  <DropdownList
                    defaultValue={
                      locationSelected !== -1
                        ? initLocations.find((item) => item.ID === locationSelected).ID.toString()
                        : 'Select'
                    }
                    items={initLocations?.map((item) => ({
                      id: item?.ID?.toString(),
                      value: item?.Description
                    }))}
                    onChange={(id) => setLocationSelected(Number(id))}
                  />

                  <p className="error-label">{isValidate && locationSelected <= 0 && GENERAL_ERROR_MESSAGE}</p>
                </Col>
                <Col sm={4} lg={1}>
                  <div className="addition-groups-button">
                    <div>
                      <Button
                        variant="link"
                        onClick={(e) => {
                          e.stopPropagation()
                          handleShowAddressModal(true)
                        }}
                      >
                        <FontAwesomeIcon icon={faPencilAlt} />
                      </Button>
                    </div>
                    <div>
                      <Button
                        variant="link"
                        onClick={(e) => {
                          e.stopPropagation()
                          handleShowAddressModal(false)
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <div className="grounding-notice">
                    <span dangerouslySetInnerHTML={{ __html: groundingData?.GroundingNotice }}></span>
                  </div>
                </Col>
              </Row>
            </StyledGroundingAdditional>
            <StyledGroundingReview>
              <Button variant="link" onClick={() => setShowCancelModal(true)} style={{ marginRight: '26px' }}>
                CANCEL
              </Button>
              <Button
                id="grounding-review-button"
                type="submit"
                variant="primary"
                onClick={() => {
                  handleReviewSubmitButtonClicked()
                }}
              >
                Review & Submit
              </Button>
            </StyledGroundingReview>
            {showCreditConfirmModal && (
              <GroundingConfirmModal
                content={confirmationText.replace('%AMOUNT%', groundingData?.creditBalanceString)}
                show={showCreditConfirmModal}
                events={{
                  onClose: () => handleRejectPayoff(),
                  setShowModal: setShowCreditConfirmModal,
                  handleAcknowledgedConfirm: handleConfirmPayoff,
                  handleClickXButton: handleResetPayoff
                }}
                isShowHeader={true}
                isShowButton={true}
                isShowYesButton={true}
                isShowNoButton={true}
                isBackdropStatic={true}
              ></GroundingConfirmModal>
            )}
            {showConfirmOdometer && (
              <GroundingConfirmModal
                content={
                  isLowerMileageLastInspection
                    ? 'The mileage you entered is lower than the mileage from the last inspection.  Are you sure this is correct?'
                    : `
                  YOU HAVE ENTERED ${props.values.odometerReading} MILES. IS THIS CORRECT?
                  `
                }
                show={showConfirmOdometer}
                events={{
                  onClose: () => {
                    props.values.odometerReading = ''
                    setShowConfirmOdometer(false)
                  },
                  setShowModal: setShowCreditConfirmModal,
                  handleAcknowledgedConfirm: () => setShowConfirmOdometer(false),
                  handleClickXButton: () => setShowConfirmOdometer(false)
                }}
                isShowHeader={false}
                isShowButton={true}
                isShowYesButton={true}
                isShowNoButton={true}
                isBackdropStatic={false}
              ></GroundingConfirmModal>
            )}
            {isMileageOptionNeedConfirm && (
              <GroundingConfirmModal
                content={confirmOdoStatement}
                show={isMileageOptionNeedConfirm}
                events={{
                  onClose: () => {
                    setOdometerOptionSelected(-1)
                    setIsMileageOptionNeedConfirm(false)
                  },
                  setShowModal: setIsMileageOptionNeedConfirm,
                  handleAcknowledgedConfirm: () => setIsMileageOptionNeedConfirm(false),
                  handleClickXButton: () => setIsMileageOptionNeedConfirm(false)
                }}
                isShowHeader={false}
                isShowButton={true}
                isShowYesButton={true}
                isShowNoButton={true}
                isBackdropStatic={false}
              ></GroundingConfirmModal>
            )}
            <FormErrorContext />
          </Form>
        )}
      </Formik>
      {showAddressModal && (
        <AddressModal
          defaultAddressDetail={isEditAddress ? initLocations.find((x) => x.ID === locationSelected) : null}
          isEditAddress={isEditAddress}
          stateList={groundingData?.states}
          show={showAddressModal}
          events={{
            onClose: () => setShowAddressModal(false),
            handleSaveAddress: handleSaveAddress,
            setIsSaveAddressToBuyer: setIsSaveAddressToBuyer
          }}
        ></AddressModal>
      )}
      {showGeneralModal && (
        <GroundingConfirmModal
          content={confirmText}
          show={showGeneralModal}
          events={{
            onClose: () => {
              setShowGeneralModal(false)
              history.push('/')
            },
            setShowModal: setShowGeneralModal,
            handleAcknowledgedConfirm: () => {
              setShowGeneralModal(false)
              if (isOpenRecall) {
                setShowRecallModal(true)
              }
              setAlreadyConfirmGeneralModal(true)
            }
          }}
          isShowHeader={false}
          isShowButton={true}
          isShowYesButton={false}
          isShowNoButton={false}
          isBackdropStatic={true}
        ></GroundingConfirmModal>
      )}
      {showRecallModal && (
        <RecallModal
          show={showRecallModal}
          events={{
            onClose: () => {
              setShowRecallModal(false)
              setAlreadyConfirmRecall(true)
            }
          }}
        />
      )}
    </StyledGroundingOptions>
  )
}

export default GroundingOptions
